<template>
    <div class="vue-org-tree">
        <div >
            <div style="padding-left: 30px;">
                <el-switch
                    v-model="horizontal"
                    active-text="横向"
                    inactive-text="纵向">
                </el-switch>
                <el-switch
                    v-model="collapsable"
                    active-text="展开"
                    inactive-text="收起">
                </el-switch>
                <!-- <el-button  type="success" plain @click="showProcessmaps">流程地图</el-button> -->
                <el-button style="margin-left: 300px;" type="warning" plain>百川金字塔</el-button>
                <el-tag effect="plain" type="info" style="margin-left: 20px;">按树状结构呈现各业务表单之间的关联关系，可以点击某一节点查看对应表单数据详情</el-tag>
            </div>
        </div>
        <br>
        <el-dialog
            width="95%"
            top="1vh"
            :fullscreen=true
            :visible.sync="isShowModelDetail"
            append-to-body>
                <ModelDetail
                    :isShowForm="isShowForm"
                    ref="modelInstance"
                    :key="loadTimer"
                    :isRead="isRead"
                    :hideAllBtn="hideAllBtn"
                    :showDiagram="true"
                    :processInstanceId="processInstanceId"
                    :formInfo="formInfo"
                    @modelComplete="handleModelComplete"
                    @exportExcelData="exportExcelData"
                    @setIsShowForm="setIsShowForm"/>
        </el-dialog>
        <vue2OrgTree 
            :data="treeData"      
            :horizontal="horizontal"      
            :collapsable="collapsable"
            :label-style="style"
            @on-expand="onExpand"
            @on-node-click="onNodeClick">
        </vue2OrgTree>
        <el-dialog
            width="95%"
            top="1vh"
            :fullscreen=true
            :visible.sync="isShowProcessMaps"
            append-to-body>
            <ProcessMaps/>
        </el-dialog>
    </div>
</template>

<script>
  import vue2OrgTree from 'vue2-org-tree';
  import ProcessMaps from './ProcessMaps.vue';
//   import ProcessDetailView from '@/pages/process/ProcessList/ProcessDetailView';
  import { getModelFormInstanceById } from '@/data-model';
  import { API_EXPORT_MODEL_FORM_EXCEL } from '@/common/constants';
  export default {
      components: {
          vue2OrgTree,
          ProcessMaps
          //   ProcessDetailView
      },
      data () {
          return {
              loadTimer: '',
              isRead: true,
              processInstanceId: '', // 流程实例Id
              formInfo: {},
              isShowForm: false,
              isShowModelDetail: false,
              horizontal: true, // true:横排,false:竖排
              collapsable: true, // 是否带节点展开功能
              expandAll: true, // 是否展开所有节点
              style: {
                  background: '#fff',
                  color: '#5e6d82'
              },
              searchParams: {
                  modelId: '',
                  name: '',
                  selectedFields: '',
                  searchCondition: [],
                  selectedApprovalStatus: ''
              },
              formBtnAuth: {// 表单按钮权限
                  isShowView: true, // 查看
                  isShowAdd: false, // 新增
                  isShowEdit: true, // 修改
                  isShowDelete: false, // 删除
                  isShowImport: false, // 导入
                  isShowExport: false, // 导出
                  isShowSyn: false// 同步流程数据
              },
              isShowDown: true, // 是否单条数据显示下载按钮，默认false
              isShowProcessMaps: false
          };
      },
      props: {
          treeData: {
              type: Object,
              default: {
                  function () {
                      return {
                          id: '0',
                          label: '该报表暂无数据'
                      };
                  }
              }
          },
          hideAllBtn: {
              type: Boolean,
              default: true
          }
      },
      created () {
          // 是否展开所有节点
          this.toggleExpand(this.treeData, this.expandAll);
      },
      methods: {
          onExpand (e, data) {
              e.stopPropagation();
              if ('expand' in data) {
                  data.expand = !data.expand;
                  if (!data.expand && data.children) {
                      this.collapse(data.children);
                  }
              } else {
                  this.$set(data, 'expand', true);
              }
          },
          onNodeClick (e, data) {
              this.handleNavModelFormEdit(data);
          },
          collapse (list) {
              list.forEach(child => {
                  if (child.expand) {
                      child.expand = false;
                  }
                  child.children && this.collapse(child.children);
              });
          },
          expandChange () {
              this.toggleExpand(this.data, this.expandAll);
          },
          toggleExpand (data, val) {
              if (Array.isArray(data)) {
                  data.forEach(item => {
                      this.$set(item, 'expand', val);
                      if (item.children) {
                          this.toggleExpand(item.children, val);
                      }
                  });
              } else {
                  this.$set(data, 'expand', val);
                  if (data.children) {
                      this.toggleExpand(data.children, val);
                  }
              }
          },
          setIsShowForm (status) {
              this.isShowForm = status;
          },
          async handleNavModelFormEdit (row) {
              this.loadTimer = new Date().getTime();
              try {
                  const loading = this.$loading({
                      lock: true,
                      text: 'Loading',
                      spinner: 'el-icon-loading',
                      background: 'rgba(0, 0, 0, 0.7)'
                  });
                  this.formInfo = await getModelFormInstanceById(row.id);
                  if (this.formInfo) {
                      this.formInfo.modelId = row.modelId;
                      this.formInfo.modelName = row.modelName;
                      this.isShowModelDetail = true;
                      this.isShowForm = false;
                      this.processInstanceId = this.formInfo.businessInstanceId;
                      this.isRead = false;
                      row.isCanEdit = this.getEditAuth();
                      // console.log(row.isCanEdit);
                      setTimeout(() => { // 调用子组件的方法
                          this.$refs.modelInstance.loadFormData(this.formInfo, this.formBtnAuth, row, this.isShowDown);
                      }, 0);
                  }
                  loading.close();
              } catch (error) {
                  console.error('解析数据异常：', error);
              }
          },
          getEditAuth () {
              let isEditAuth = false;
              let currentUserStr = sessionStorage.getItem('currentUserInfo');
              if (currentUserStr) {
                  let currentUserInfo = JSON.parse(currentUserStr);
                  let resources = currentUserInfo.resources;
                  // console.log(resources);
                  if (resources) {
                      for (let i = 0; i < resources.length; i++) {
                          if (resources[i].resourceUrl === 'ReportFormDataEditBtn') { // 是否可以点击报表进行数据修改
                              isEditAuth = true;
                              break;
                          }
                      }
                  }
              }
              return isEditAuth;
          },
          async exportExcelData (rowInfo) {
              let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
              let approvalInstanceId = rowInfo.approvalInstanceId;
              let formDataId = rowInfo.id;
              let condition = encodeURIComponent(JSON.stringify(this.searchParams.searchCondition));
              url = url.replace(':modelId', this.formInfo.modelId).replace(':selectedFields', this.searchParams.selectedFields).replace(':searchCondition', condition).replace(':approvalInstanceId', approvalInstanceId).replace(':isApprovalForm', false).replace(':needSumData', false);
              url = url + '&formDataId=' + formDataId;
              // console.log(url);
              this.download(url);
          },
          download (url) {
              var iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.src = url;
              document.body.appendChild(iframe);
          },
          handleModelComplete (model) {
              this.$emit('modelComplete', model);
              this.isShowModelDetail = false;
          },
          showProcessmaps () {
              this.isShowProcessMaps = true;
          }
          //   renderContent (h, data) {
          //       console.log(data);
          //       if (data.id === '72dd858b5c0c4490870eacdce8e40c63') {
          //           return (
          //               <iframe class="detailUrl-page" src="http://localhost:8088/bcbpm/editor/#/processes3/ff96c1e41b9d4c9f92c27e8fc3eb2418" frameborder="0"></iframe>
          //           );
          //       } else {
          //           return (data.label);
          //       }
          //   }
      }
};
</script>
<style lang="less">
    @import '~assets/styles/org.css';
    .vue-org-tree {
        .popEditModelDetail {
            .el-dialog__body {
                padding: 5px 30px 0px 0px;
                color: #606266;
                font-size: 14px;
                word-break: break-all;
                height:~"calc(100% - 8vh)";
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/VueOrgTree/VueOrgTree.vue